define('drops/list/cqListTools',[
    'jquery',
    'underscore',
    'lq',
    'lq/design/editors/dropPersistence',
    'lq/dialogs/message'
], function ($, _, lq, dropPersistence, message) {
    'use strict';

    var ensureGoToProcessCapture = function (listDrop) {
        if (listDrop.rootDrop.canvas.actionType === "Widget") return;
        var isWidgetList = !!listDrop.designData.cqData.isWidgetList;
        
        var eventsDrop = _.find(listDrop.rootDrop.pool, function (d) {
            return d.type === "Events" && !d.renderInBackground
        });
        if (!eventsDrop) return;

        var goToProcessMapping = _.find(eventsDrop.data.eventMappings, function (em) {
            return em.name === "GoToProcess" 
                && (!isWidgetList ^ em.eventSourceName == "[modalWidget].");
        });

        var goToProcessActions = [
            {
                action: "Update Local Parameter : ProcessId",
                parameter: "ProcessId"
            },
            {
                action: "Event : MP Start Process (ProcessId)",
                eventName: "MP Start Process",
                eventParameter: "ProcessId"
            }
        ];

        if (!goToProcessMapping) {
            var newMapping = {
                actionTypes: {},
                actions: goToProcessActions,
                conditionId: "",
                conditionName: "",
                eventSourceName: isWidgetList ? "[modalWidget]." : "",
                invertCondition: false,
                isPrivate: false,
                name: "GoToProcess",
            };
            if (isWidgetList) {
                var modalActionDrop = listDrop.findChildDropWhere(function (d) { return d.type === "ModalAction"; });
                newMapping.sourceDropId = modalActionDrop.data.id;
            } 
            eventsDrop.data.eventMappings.push(newMapping);
        }
        dropPersistence.save(eventsDrop, false, true);
    };

    var ensureQuery = function (listDrop) {
        if (listDrop.data.dataSource) return;

        var rawsqlDropDefinition = {
            type: "RawSql",
            name: "Raw Sql",
            designData: { renderHidden: lq.isInMockMode() },
            data: _.get(listDrop, ['designData', 'cqData', 'isProcessList']) ? getProcessSQLData(listDrop) : getWidgetSQLData()
        };

        listDrop.rootDrop.insertDrop(listDrop.rootDrop, { x: 0, y: 0 }, rawsqlDropDefinition)
            .then(function (drop) {
                listDrop.data.dataSource = drop.data.name;
                listDrop.data.keyColumn = _.get(listDrop, ['designData', 'cqData', 'isProcessList']) ? "ProcessId" : "ActionId";
                dropPersistence.save(listDrop, false, true);

                var eventsDrop = _.find(listDrop.rootDrop.pool, function (d) {
                    return d.type === "Events" && !d.renderInBackground
                });
                if (!eventsDrop)
                    message.show({
                        title: "Error",
                        message: "Cannot set PageLoad event action, no Eventhandlers drop found."
                    });
                else {
                    var runQueryAction =
                    {
                        command: "",
                        dataSource: drop.data.id,
                        global: false,
                        mapping: "",
                        parameter: "",
                        action: "Execute : Query : " + drop.data.name,
                    };

                    var pageLoadMapping = _.find(eventsDrop.data.eventMappings, function (em) {
                        return em.name === "PageLoad";
                    });

                    if (!pageLoadMapping) eventsDrop.data.eventMappings.push({
                        name: "PageLoad",
                        actions: [runQueryAction],
                        conditionName: "",
                        eventSourceName: "",
                        actionTypes: {},
                        isPrivate: false,
                        conditionId: "",
                        invertCondition: false
                    })
                    else pageLoadMapping.actions.push(runQueryAction);
                    dropPersistence.save(eventsDrop, false, true);
                }
            });
    };

    var findRawSqlDrop = function (listDrop) {
        var rawsqlDropName = listDrop.data.dataSource;
        if (!rawsqlDropName) return;

        return _.find(listDrop.rootDrop.pool, function (drop) {
            return drop.data.type === "RawSql" && drop.data.name === rawsqlDropName;
        });
    };

    var updateQuery = function (listDrop) {
        if (!listDrop.designData.cqData && listDrop && listDrop.rootDrop) return;

        var rawsqlDrop = findRawSqlDrop(listDrop);

        rawsqlDrop.data.sql = listDrop.designData.cqData && listDrop.designData.cqData.isProcessList
            ? getProcessListSQL(listDrop)
            : getWidgetListSQL();

        dropPersistence.save(rawsqlDrop, false, true);
    };

    var deleteEvents = function (listDrop) {
        if (!listDrop.designData.cqData || !listDrop || !listDrop.rootDrop) return;

        var rawsqlDrop = findRawSqlDrop(listDrop);
        if (!rawsqlDrop) return;
        var rawsqlName = rawsqlDrop.data.name;
        rawsqlDrop.delete();

        var eventsDrop = _.find(listDrop.rootDrop.pool, function (d) {
            return d.type === "Events" && !d.renderInBackground
        });

        if (!eventsDrop)
            message.show({
                title: "Error",
                message: "Cannot set PageLoad event action, no Eventhandlers drop found."
            });
        else {
            var pageLoadMapping = _.find(eventsDrop.data.eventMappings, function (em) {
                return em.name === "PageLoad";
            });
            if (pageLoadMapping && pageLoadMapping.actions) {
                pageLoadMapping.actions = _.filter(pageLoadMapping.actions, function (a) {
                    return a.dataSource !== rawsqlName;
                });
            }
            if (pageLoadMapping.actions.length === 0) {
                eventsDrop.data.eventMappings = _.reject(eventsDrop.data.eventMappings, { name: "PageLoad" });
            }
            if (listDrop.designData.cqData.isWidgetList) {
                var modalActionDrop = listDrop.findChildDropWhere(function (d) { return d.type === "ModalAction"; });
                if (modalActionDrop)
                    eventsDrop.data.eventMappings = _.reject(eventsDrop.data.eventMappings, function (em) {
                        return em.name === "GoToProcess" && em.sourceDropId === modalActionDrop.data.id;
                    });
            } else if (!listDrop.rootDrop.findChildDropWhere(function (drop) { 
                    return _.get(drop, ['data', 'eventing', 'clicked', 'raisedEventName']) === "GoToProcess" && drop.type !== "ModalAction" && drop.data.id !== listDrop.data.id;
                })) {
                eventsDrop.data.eventMappings = _.reject(eventsDrop.data.eventMappings, function (em) {
                    return em.name === "GoToProcess" && !em.eventSourceName;
                });
            }
            dropPersistence.save(eventsDrop, false, true);
        }
    }

    var getProcessListSQL = function (listDrop) {
        return (
`DECLARE @0 UNIQUEIDENTIFIER = '00000000-0000-0000-0000-000000000000'
DECLARE @UserId UNIQUEIDENTIFIER = IIF(:CurrentUser = @0, NULL, :CurrentUser )
DECLARE @RootEntityId UNIQUEIDENTIFIER = IIF(:RootEntity = '', NULL, :RootEntity )
DECLARE @PageId UNIQUEIDENTIFIER = :PageId
DECLARE @MockSessionId UNIQUEIDENTIFIER = IIF(:MockSessionId = '', NULL, :MockSessionId )
DECLARE @ShowTodos BIT = ${listDrop.designData.cqData.showTodos ? "1" : "0"}
DECLARE @ShowAdhocs BIT = ${listDrop.designData.cqData.showAdhocs ? "1" : "0"}
DECLARE @ShowHidden BIT = ${listDrop.designData.cqData.showHidden ? "1" : "0"}
DECLARE @PageWidgetId UNIQUEIDENTIFIER = IIF(:PageWidgetId = '', NULL, :PageWidgetId )
DECLARE @Language NVARCHAR(100) = :CurrentLanguageName
DECLARE @EntityId UNIQUEIDENTIFIER = IIF(:EntityId = '', NULL, :EntityId )
DECLARE @Search NVARCHAR(500) = :Search
DECLARE @SearchInAllProcesses BIT = 1
DECLARE @Tag NVARCHAR(100) = ${listDrop.designData.cqData.tag ? "'" + listDrop.designData.cqData.tag + "'" : "NULL"}
DECLARE @DeviceId UNIQUEIDENTIFIER = :CurrentDeviceId

EXEC {RuntimeSchema}.sys_Pages_Processes @UserId
                                , @RootEntityId
                                , @PageId
                                , @MockSessionId
                                , @ShowTodos
                                , @ShowAdhocs
                                , @ShowHidden
                                , @PageWidgetId
                                , @Language
                                , @EntityId
                                , @Search
                                , @SearchInAllProcesses
                                , @Tag
                                , @DeviceId`);
    };

    var getProcessSQLData = function (listDrop) {
        return {
            name: "ProcessListQuery",
            sql: getProcessListSQL(listDrop),
            outputs: [
                {
                    alias: "ProcessId",
                    outputType: "System.Guid"
                },
                {
                    alias: "Name",
                    outputType: "System.String"
                },
                {
                    alias: "ShortName",
                    outputType: "System.String"
                },
            ],
            keyOutput: "Counter",
            totalCountParameter: "TodosCounter"
        };
    };

    var getWidgetListSQL = function () {
        return (
`DECLARE @PageId UNIQUEIDENTIFIER = :PageId
DECLARE @MockSessionId UNIQUEIDENTIFIER = IIF(:MockSessionId = '', NULL, :MockSessionId )

EXEC {RuntimeSchema}.[sys_Pages_Widgets] @PageId, @MockSessionId`);
    };

    var getWidgetSQLData = function () {
        return {
            name: "WidgetListQuery",
            sql: getWidgetListSQL(),
            outputs: [
                {
                    alias: "ActionId",
                    outputType: "System.Guid"
                },
                {
                    alias: "PageWidgetId",
                    outputType: "System.Guid"
                }
            ]
        }
    };

    return {
        ensureQuery: ensureQuery,
        updateQuery: updateQuery,
        deleteEvents: deleteEvents,
        ensureGoToProcessCapture: ensureGoToProcessCapture
    };

});
